module.exports = __webpack_public_path__ + "static/img/center_bg_url.f3a336a7.png";